import { ArrowLeft, X } from "lucide-react";

import { genericClientLogoUrl } from "../lib/constants";
import LogoLockup from "./LogoLockup";

// v0 keeps an unavailable back button visible but greyed out, and hides close.
const NavButton = ({ hidden, dimWhenHidden, onClick, ariaLabel, children }) => (
  <button
    type="button"
    onClick={onClick}
    aria-label={ariaLabel}
    // Unavailable buttons stay in the layout but must not be reachable by keyboard.
    tabIndex={hidden ? -1 : undefined}
    aria-hidden={hidden || undefined}
    className={`inline-flex size-11 items-center justify-center rounded transition-colors hover:bg-surface-muted active:bg-surface-pressed ${
      hidden
        ? `pointer-events-none ${
            dimWhenHidden ? "text-border" : "text-ink opacity-0"
          }`
        : "text-ink"
    }`}
  >
    {children}
  </button>
);

const Nav = ({
  client,
  nextStep,
  prevStep,
  showPrevStep,
  showExit,
  showActions = true,
  showLockup = true,
}) => {
  return (
    // Inset so the 20px icons in the 44px buttons line up with the content's 24px edge.
    <nav className="grid shrink-0 grid-cols-[44px_1fr_44px] items-center px-3 pb-2 pt-6">
      {showActions ? (
        <NavButton
          hidden={!showPrevStep}
          dimWhenHidden
          onClick={(e) => {
            prevStep();
            e.currentTarget.blur(); // Necessary to remove focus style after button is selected
          }}
          ariaLabel="Back"
        >
          <ArrowLeft aria-hidden className="size-5" strokeWidth={1.75} />
        </NavButton>
      ) : (
        <span />
      )}
      <div className="flex justify-center">
        {showLockup && (
          <LogoLockup
            logoUrl={client.logoUrl ?? genericClientLogoUrl}
            label={client.displayName}
          />
        )}
      </div>
      {showActions ? (
        <NavButton
          hidden={!showExit}
          onClick={(e) => {
            nextStep("exit-confirmation");
            e.currentTarget.blur(); // Necessary to remove focus style after button is selected
          }}
          ariaLabel="Exit"
        >
          <X aria-hidden className="size-5" strokeWidth={1.75} />
        </NavButton>
      ) : (
        <span />
      )}
    </nav>
  );
};

export default Nav;
